
























import { Component, Prop, Vue } from 'vue-property-decorator';
import SpeakerIcon from './SpeakerIcon.vue';
import MedicineImage from './MedicineImage.vue';

export interface MedicineInfo {
    imagePath: string;
    medicineName: string;
    medicinePhoneticName: string;
    doseAmount: number;
    doseUnit: string;
    imageWidth: number;
    imageHeight: number;
}

@Component({
    components: {
        MedicineImage,
        SpeakerIcon,
    },
})
export default class MedicineInformationComponent extends Vue {
    @Prop() private medicineInfo!: MedicineInfo;
    @Prop() private isEmphasized!: boolean;
    @Prop() private isImageLoadCompleted!: boolean;

    get imagePath(): string {
        return this.medicineInfo.imagePath;
    }
    get medicineName(): string {
        return this.medicineInfo.medicineName;
    }
    get doseAmount(): number {
        return this.medicineInfo.doseAmount;
    }

    get doseUnit(): string {
        return this.medicineInfo.doseUnit;
    }

    get imageWidth(): number {
        return this.medicineInfo.imageWidth;
    }
    get imageHeight(): number {
        return this.medicineInfo.imageHeight;
    }

    get speakText(): string {
        return this.medicineInfo.medicinePhoneticName;
    }

    get medicineAmountUnit(): string {
        return `${this.doseAmount} ${this.doseUnit}`;
    }

}
